import React from 'react';
import { PulseLoader as RSPulseLoader } from 'react-spinners';
import { useTheme } from 'styled-components';

export type PulseLoaderProps = Omit<
  React.ComponentPropsWithoutRef<typeof RSPulseLoader>,
  'color' | 'cssOverride' | 'loading' | 'margin' | 'size' | 'speedMultiplier'
>;

const PulseLoader: React.FC<PulseLoaderProps> = (props) => {
  const theme = useTheme();

  return <RSPulseLoader color={theme.palette.actionPrimary.main} {...props} />;
};

export default PulseLoader;
